import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2 text-sm text-muted-foreground', className)} role="status" aria-live="polite">
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      {label ? <span>{label}</span> : null}
    </span>
  );
}

export function FullScreenLoader({ label }: { label?: string }) {
  return (
    <div className="fixed inset-0 grid place-items-center bg-background">
      <Spinner label={label ?? 'Loading'} />
    </div>
  );
}
